import React, { useState } from "react";
import { BlockJson, CategoryJsonModel } from "../../models/BlockTransportSystemJsonModel";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IProps {
    category?: CategoryJsonModel;
    blocks?: BlockJson[];
    isShow: boolean;
    onClickPublish: (categoryId: string, blockType: string, progressEvent: (name: string, count: number, totalCount: number) => void) => Promise<void>;
    onClickClose: () => void;
}

const CategoryBlocksPublishModal = ({
    category,
    blocks,
    isShow,
    onClickPublish,
    onClickClose
}: IProps) => {
    const { t } = useTranslation();
    const [isWorking, setIsWorking] = useState<boolean>(false);
    const [targetType, setTargetType] = useState<string>();
    const typeCounts = blocks
        ?.filter((block) => block?.data?.categoryId === category?.id)
        .map((block) => block.data.type)
        .reduce<Record<string, number>>((acc, cur) => {
            acc[cur] = (acc[cur] || 0) + 1;
            return acc;
        }, {});

    return (
        <Modal show={isShow} onHide={() => onClickClose()}>
            <Modal.Header closeButton>{t("block-type-list")}</Modal.Header>
            <Modal.Body>
                <Form.Select
                    disabled={isWorking}
                    onChange={(e) => setTargetType(e.target.value)}
                >
                    <option key={""} value={""}>{t("none")}</option>
                    {Object.entries(typeCounts).map(([key, value]) =>
                        <option key={key} value={key}>{`${key}(${value})`}</option>
                    )}
                </Form.Select>
                <div id="progressDisplay"></div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={!category?.id || !targetType || isWorking}
                    variant="primary"
                    onClick={async () => {
                        setIsWorking(true);
                        try {
                            await onClickPublish(category?.id!, targetType!, (name: string, count: number, totlaCount: number) => {
                                const progress = document.getElementById("progressDisplay");
                                progress.textContent = `${name} : ${count}/${totlaCount}`;
                            });
                            onClickClose();
                        } finally {
                            setIsWorking(false);
                        }
                    }}>
                    {isWorking &&
                        <Spinner
                            className="me-1"
                            animation="border"
                            size="sm"
                            role="status"
                        />}
                    {t("button-publish")}
                </Button>
                <Button
                    disabled={isWorking}
                    variant="secondary"
                    onClick={() => {
                        onClickClose();
                    }}>
                    {t("button-close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CategoryBlocksPublishModal;
